import React from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";


const CustomDataViewer = ({ cell }) => {

    return (
      cell === undefined || cell === null ? <div/> :
      Object.keys(cell).includes('tooltip') && cell.tooltip !== '' && 
          cell.tooltip !== null && cell.tooltip !== undefined ? 
          <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-${cell.row}-${cell.column}`}>{cell.tooltip}</Tooltip>}>
              <div className="excel-table-cell">{cell.value}</div>
          </OverlayTrigger> 
          : <div style={{ cursor: "pointer" }} className={cell.className + ' excel-table-cell'}
          >{cell.value}</div>
    );
};

export default CustomDataViewer;